export function getPageName(pathname: string): string {
  const name =
    pathname === "/" ? "home" : pathname.slice(1).replace(/\//g, "-");
  return `page-${name}`;
}
